import React from 'react'
import './loader.css';

function Loader() {
    
  return (
        <div className='loader_wrapper'>
            <span className="loader"></span>
        </div> 
  )
}

export default Loader